import { create } from 'zustand';

const useVideoWallStore = create((set, get) => ({
  // Grid layout
  layoutMode: '2x2',
  setLayoutMode: (mode) => set({ layoutMode: mode }),

  // Camera assignments: { cellIndex: cameraObject }
  cells: {},
  assignCamera: (cellIndex, camera) => set((state) => ({
    cells: { ...state.cells, [cellIndex]: camera }
  })),
  removeCamera: (cellIndex) => set((state) => {
    const next = { ...state.cells };
    delete next[cellIndex];
    return { cells: next };
  }),
  clearAllCells: () => set({ cells: {} }),

  // Expanded single camera view
  expandedCell: null,
  setExpandedCell: (cellIndex) => set({ expandedCell: cellIndex }),

  // Timeline / Archive
  isLive: true,
  setIsLive: (live) => set({ isLive: live }),
  positionMs: null,
  setPositionMs: (ms) => set({ positionMs: ms }),

  // Sidebar
  sidebarOpen: true,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  sidebarSearch: '',
  setSidebarSearch: (term) => set({ sidebarSearch: term }),

  // Camera list from API
  cameras: [],
  camerasLoading: false,
  setCameras: (cameras) => set({ cameras }),
  setCamerasLoading: (loading) => set({ camerasLoading: loading }),

  // Helpers
  getPlacedCameraIds: () => {
    return new Set(Object.values(get().cells).map(c => c.id));
  },
  getCellCount: () => {
    const layouts = {
      '1x1': 1, '2x2': 4, '1+5': 6, '2x3': 6, '2x4': 8, '3x3': 9, '4x4': 16
    };
    return layouts[get().layoutMode] || 4;
  },
  getGridDimensions: () => {
    const dims = {
      '1x1': { cols: 1, rows: 1 },
      '2x2': { cols: 2, rows: 2 },
      '1+5': { cols: 3, rows: 2 },
      '2x3': { cols: 3, rows: 2 },
      '2x4': { cols: 4, rows: 2 },
      '3x3': { cols: 3, rows: 3 },
      '4x4': { cols: 4, rows: 4 },
    };
    return dims[get().layoutMode] || { cols: 2, rows: 2 };
  },
  getStreamQuality: () => {
    const count = Object.keys(get().cells).length;
    if (count <= 4) return 'primary';
    return 'secondary';
  },
}));

export default useVideoWallStore;
